"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = exports.Bar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Bar = _styledComponents["default"].div.withConfig({
  displayName: "Progressstyled__Bar",
  componentId: "jhcx5u-0"
})(function (_ref) {
  var _ref$theme = _ref.theme,
      color = _ref$theme.color,
      spacing = _ref$theme.spacing;
  return {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: spacing.inline['6xs'],
    backgroundColor: color.neutral['06'],
    borderRadius: spacing.inline['6xs']
  };
});

exports.Bar = Bar;

var Progress = _styledComponents["default"].div.withConfig({
  displayName: "Progressstyled__Progress",
  componentId: "jhcx5u-1"
})(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      color = _ref2$theme.color,
      spacing = _ref2$theme.spacing;
  return {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    backgroundColor: color.brandSecondary.dark,
    padding: 0,
    height: spacing.inline['6xs'],
    width: '100%',
    borderRadius: spacing.inline['6xs'],
    transition: 'transform 0.3s ease-in-out',
    transformOrigin: 'left'
  };
});

exports.Progress = Progress;